/** ***********
*
* <shared.module.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  PEREIRA Thomas [SOPRA STERIA] [thomas.pereira@soprasteria.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
 * All rights reserved.
**************/

import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { OrderbyModule } from '../shared/orderby/orderby.module';
import { QuickLinkComponent } from '../quick-link/quick-link.component';
import { QuicklinkviewComponent } from '../quick-link-view/quick-link-view.component';
import { TranslateModule } from '@ngx-translate/core';
import { AppMaterialModule } from '../../material.modules';
import { DialogValidationComponent } from './dialog/dialog-validation/dialog-validation.component';
import { TypeofPipe } from 'src/app/pipes/type-of.pipe';
import { CertificateRenewalPipe } from 'src/app/pipes/certificate-renewable.pipe';
import { ShowIfTruncatedDirective } from 'src/app/directives/showIfTruncated.directive';
import { DndDirective } from 'src/app/directives/draganddrop.directive';
import { ExtractPropertyPipe } from 'src/app/pipes/extract-property.pipe';
import { HiddenDirective } from 'src/app/directives/hidden';
import { TransformPropertyPipe } from 'src/app/pipes/transform-property.pipe';
import { ListFilterPipe } from 'src/app/pipes/list-filter.pipe';
import { SortPipe } from 'src/app/pipes/sort.pipe';
import { LayoutModule } from '@angular/cdk/layout';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { FileSizeFormatPipe } from '../../pipes/file-size-format.pipe';
import { BatteryComponent } from './battery/battery.component';
import { MoreKpiComponent } from './kpi/more-kpi/more-kpi.component';
import { SelectionLabelPipe } from 'src/app/pipes/selection-label.pipe';
import { ListSelectionCheckboxStatePipe } from 'src/app/pipes/list-selection-checkbox-state.pipe';
import { FontAwesomeModule } from './font-awesome.module';
import { WebsocketInfoComponent } from './header/websocket-info.component';
import { ChipWrapperComponent } from './chip-wrapper/chip-wrapper.component';
import { ZoneNamePipe } from 'src/app/pipes/zone-name.pipe';
import { MomentTranslatePipe } from 'src/app/pipes/moment-translate.pipe';
import { ReplacePipe } from 'src/app/pipes/replace.pipe';
import { JoinPipe } from 'src/app/pipes/join.pipe';
import { AdditionalDataKeyvaluePipe } from 'src/app/pipes/additional-data-keyvalue.pipe';
import { DeviceProviderPipe} from 'src/app/pipes/device-provider.pipe';
import { ConversionPipe } from 'src/app/pipes/conversion.pipe';
import { RangeInputComponent } from './range-input/range-input.component';
import { EmptyStateFillFieldComponent } from './empty-state-fill-field/empty-state-fill-field.component';
import { AssociateComponent } from '../quick-link/associate/associate.component';
import { ListExcludePipe } from 'src/app/pipes/list-exclude.pipe';
import { TypedAsPipe } from './typed-as.pipe';
import { EventSourceNamePipe } from 'src/app/pipes/format-event-source.pipe';
import { TutorialComponent } from './tutorial/tutorial.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        OrderbyModule,
        ReactiveFormsModule,
        LayoutModule,
        AppMaterialModule,
        FontAwesomeModule,
        TranslateModule,
    ],
    declarations: [
        QuickLinkComponent,
        QuicklinkviewComponent,
        AssociateComponent,
        FileUploaderComponent,
        DialogValidationComponent,
        ChipWrapperComponent,
        TypeofPipe,
        ExtractPropertyPipe,
        TransformPropertyPipe,
        CertificateRenewalPipe,
        ListFilterPipe,
        SortPipe,
        FileSizeFormatPipe,
        ShowIfTruncatedDirective,
        HiddenDirective,
        DndDirective,
        SelectionLabelPipe,
        ListSelectionCheckboxStatePipe,
        BatteryComponent,
        MoreKpiComponent,
        WebsocketInfoComponent,
        ZoneNamePipe,
        MomentTranslatePipe,
        ReplacePipe,
        JoinPipe,
        AdditionalDataKeyvaluePipe,
        DeviceProviderPipe,
        ConversionPipe,
        RangeInputComponent,
        EmptyStateFillFieldComponent,
        ListExcludePipe,
        TypedAsPipe,
        EventSourceNamePipe,
        TutorialComponent,
    ],
    exports: [
        QuickLinkComponent,
        QuicklinkviewComponent,
        AssociateComponent,
        FileUploaderComponent,
        OrderbyModule,
        TypeofPipe,
        ExtractPropertyPipe,
        TransformPropertyPipe,
        CertificateRenewalPipe,
        ListFilterPipe,
        SortPipe,
        ShowIfTruncatedDirective,
        HiddenDirective,
        DndDirective,
        SelectionLabelPipe,
        ListSelectionCheckboxStatePipe,
        BatteryComponent,
        MoreKpiComponent,
        FontAwesomeModule,
        AppMaterialModule,
        ChipWrapperComponent,
        ZoneNamePipe,
        MomentTranslatePipe,
        ReplacePipe,
        JoinPipe,
        AdditionalDataKeyvaluePipe,
        DeviceProviderPipe,
        ConversionPipe,
        RangeInputComponent,
        TranslateModule,
        EmptyStateFillFieldComponent,
        ListExcludePipe,
        TypedAsPipe,
        EventSourceNamePipe
    ]
})
export class SharedModule { }
